function initForms() {
  document
    .querySelectorAll<HTMLFormElement>(".echobox-custom-form-block")
    .forEach((container) => {
      const form = container.querySelector("form");

      form?.addEventListener("submit", async (e) => {
        e.preventDefault();
        const formdata = new FormData(e.target as HTMLFormElement);
        const body = new URLSearchParams(formdata as any);
        const action = form.getAttribute("action") ?? "";

        try {
          const res = await fetch(action, {
            method: "POST",
            body,
          });

          if (!res.ok) {
            throw new Error("Something went wrong");
          }

          displayAlert(container, "success");
          form.remove();
        } catch (e) {
          console.error(e);

          displayAlert(container, "error");
        }
      });
    });
}

/**
 * Handles displaying an alert message in a container element.
 *
 * @param container - The container element to display the alert in.
 * @param type - The type of alert to display. Defaults to "success".
 * @param message - The message to display in the alert. Defaults to an empty string.
 */
function displayAlert(container: HTMLElement, type = "success") {
  const alert = container.querySelector(`.${type}`);
  const headerHeight = document.querySelector("#header")?.clientHeight ?? 0;

  window.scrollTo({
    top: container.offsetTop - headerHeight - 10,
    behavior: "smooth",
  });

  if (alert instanceof HTMLDivElement) {
    alert.classList.remove("neb-hidden");
  }
}

document.addEventListener("DOMContentLoaded", initForms);
document.addEventListener("content-added", initForms);
